import { ReactNode } from 'react';

interface SidebarGroupProps {
  label?: string;
  children: ReactNode;
  collapsed?: boolean;
}

export const SidebarGroup = ({ label, children, collapsed = false }: SidebarGroupProps) => {
  return (
    <div className="flex flex-col gap-0.5">
      {label && !collapsed && (
        <div className="px-2.5 pt-3 pb-1.5 text-[11px] font-semibold uppercase tracking-wider text-dark-invirtus/40 font-body">
          {label}
        </div>
      )}
      {label && collapsed && <div className="my-2 border-t border-light-lila/40" />}
      <div className="flex flex-col gap-px">{children}</div>
    </div>
  );
};
